// Shared copy for the "exempt existing (returning) customers from ID verification" onboarding-policy
// control. Used by both the dashboardv2 (OnboardingFlowSettings) and the legacy v1 configuration
// screens so the security-sensitive wording stays identical across the two designs and cannot drift.

export const EXEMPT_EXISTING_ID_VERIFICATION_HEADING =
    'Returning Customer Identity Verification'

export const EXEMPT_EXISTING_ID_VERIFICATION_LABEL =
    'Exempt existing (returning) customers from identity/face verification during onboarding'

export const EXEMPT_EXISTING_ID_VERIFICATION_WARNING =
    "Security warning: enabling this removes the biometric check that ties a returning customer's app " +
    're-enrollment to the real account holder. Only enable if your institution has compensating controls ' +
    'in place. Leave off unless it is explicitly required.'

// Exempting returning customers from ID/face verification is security-sensitive, so enabling it
// is gated behind a one-time acknowledgement modal (mirrors the NIN enforcement gate) in both the
// legacy and v2 configuration screens. Declining leaves the exemption off.
export const EXEMPT_EXISTING_ID_VERIFICATION_MODAL_TITLE =
    'Exempt Returning Customers from Verification'

export const EXEMPT_EXISTING_ID_VERIFICATION_CONFIRMATION_LABEL =
    'I understand the security risk and confirm my institution has compensating controls in place.'

// Identity document types an institution can accept for new-customer onboarding.
// Keys must match the backend's IdDocumentType SmartEnum keys exactly (NIN, BVN, GB-NIN).
export const ACCEPTED_ID_TYPE_OPTIONS: { key: string; label: string }[] = [
    { key: 'NIN', label: 'National Identification Number (NIN)' },
    { key: 'BVN', label: 'Bank Verification Number (BVN)' },
    { key: 'GB-NIN', label: 'Gambian National Identity Number (GB-NIN)' },
]

export const ACCEPTED_ID_TYPES_HEADING = 'Accepted ID Types'

export const ACCEPTED_ID_TYPES_HELP_TEXT =
    'Choose which identity document types your institution accepts for new-customer onboarding. At least one must be selected.'

// Streamlined onboarding (arbitrary phone number entry) is the only mode that requires
// explicit Terms and Conditions agreement. Shared across the legacy and v2 configuration
// screens so the link and copy stay identical.
export const ONBOARDING_TERMS_URL =
    'https://bankonetracker.atlassian.net/wiki/external/ODAyOTY4NTMxZmNhNDZjNzgwZmI5MWVkY2U1MTc4ZDU'

export const ONBOARDING_TERMS_MODAL_TITLE = 'Terms and Conditions'

export const ONBOARDING_TERMS_MODAL_BODY =
    'Allowing users to enter their own phone number for verification requires agreeing to the Terms ' +
    'and Conditions for streamlined onboarding. Please review the terms before continuing.'

// Enabling NIN as an accepted ID type only works if the institution's BankOne CBA isn't also
// forcing BVN submission at account creation — surfaced as a one-time acknowledgement when NIN
// is turned on, in both the legacy and v2 configuration screens.
export const NIN_ID_KEY = 'NIN'

export const NIN_ENFORCEMENT_MODAL_TITLE = 'Enable NIN for Onboarding'

export const NIN_ENFORCEMENT_CONFIRMATION_LABEL =
    'I confirm that I have reviewed the BankOne CBA configuration and understand that BVN ' +
    'enforcement may prevent NIN-based account opening.'
